import type { FunctionComponent, ReactNode } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import type { TranslationKey } from '~/shared/internationalization/translation';
import { Button } from '~/ui/core/button/Button';
import { IconCrossSmall } from '~/ui/core/icons';
import { LanguagePicker } from '~/ui/domain/language-picker/LanguagePicker';

export const SidepanelHeaderTitle: FunctionComponent<{ readonly children: ReactNode }> = ({ children }) => (
    <div className="flex min-w-full flex-col gap-s" data-testid="learning-opportunity-header-title">
        {children}
    </div>
);

export const SidepanelHeaderNavigation: FunctionComponent<{
    readonly activeLanguage: string;
    readonly availableLanguages: readonly string[];
    readonly actions?: ReactNode;
    readonly isLanguagePickerDisabled?: boolean;
    readonly onClose: () => void;
    readonly onLanguageChange: (language: string) => void;
}> = ({ actions, activeLanguage, availableLanguages, isLanguagePickerDisabled = false, onClose, onLanguageChange }) => {
    const translate = useTranslate();

    return (
        <div className="flex w-full items-center justify-between gap-l" data-testid="sidepanel-header-navigation">
            <div className="flex items-center gap-l">
                <Button aria-label="close" iconOnly={true} size="sm" variant="secondary" onClick={onClose}>
                    <IconCrossSmall />
                </Button>
                <div className="h-xxl w-px bg-gray-300" />
                <LanguagePicker
                    activeText={translate(`common.languages.${activeLanguage}` as TranslationKey)}
                    disabled={isLanguagePickerDisabled}
                    languages={availableLanguages.map((code) => ({
                        id: code,
                        name: translate(`common.languages.${code}` as TranslationKey),
                    }))}
                    onLanguageChange={onLanguageChange}
                />
            </div>
            {actions !== undefined && <div className="flex shrink-0 items-center gap-s">{actions}</div>}
        </div>
    );
};
